// extracted by mini-css-extract-plugin
export default {"root":"nCAxP","svg":"Oc0Y8","svgRTL":"DCFRz"};